import React from "react";
import imgName from "./Img/pexels-rdne-6517325.jpg";
import photoshopLogo from "./Img/adobe2 (2).jpg";
import AdobePic from "./Img/adobe3.png";
import ReviewsSection from "./ReviewsSection"; // adjust path if needed

import {
  FaLayerGroup,
  FaMagic,
  FaFont,
  FaPaintBrush,
  FaCamera,
  FaPenNib,
  FaVideo,
  FaCube,
  FaRunning,
  FaFileImage,
} from "react-icons/fa";

const topics = [
  {
    icon: <FaPaintBrush />,
    title: "Basic Tools & Interface",
    description: "Get familiar with Photoshop's workspace and essential tools.",
  },
  {
    icon: <FaCamera />,
    title: "Image Editing",
    description:
      "Retouch, crop, and enhance photos with professional techniques.",
  },
  {
    icon: <FaLayerGroup />,
    title: "Layers & Masks",
    description: "Master non-destructive editing using layers and masking.",
  },
  {
    icon: <FaFont />,
    title: "Typography & Text Effects",
    description: "Create stunning text styles and compositions.",
  },
  {
    icon: <FaMagic />,
    title: "Photo Manipulation",
    description: "Blend, warp, and transform images creatively.",
  },
  {
    icon: <FaFileImage />,
    title: "Export & File Formats",
    description: "Save and export projects for print or digital use.",
  },
];

// Usage Areas
const usageAreas = [
  {
    icon: <FaPaintBrush />,
    title: "Photoshop Basics",
    description: "Master image editing, retouching, and creative compositions.",
  },
  {
    icon: <FaPenNib />,
    title: "Illustrator Design",
    description: "Create stunning vector graphics, logos, and illustrations.",
  },
  {
    icon: <FaVideo />,
    title: "Premiere Pro Editing",
    description:
      "Edit professional videos with smooth transitions and effects.",
  },
  {
    icon: <FaMagic />,
    title: "After Effects Animation",
    description: "Design motion graphics and cinematic visual effects.",
  },
  {
    icon: <FaCube />,
    title: "Adobe Dimension",
    description: "Create realistic 3D product mockups and branding visuals.",
  },
  {
    icon: <FaRunning />,
    title: "Lightroom Photography",
    description: "Enhance and color-correct your photos like a pro.",
  },
];

// Adobe Companies Items
const futureScope = [
  {
    icon: "🎬",
    title: "Pixar",
    text: "Uses Adobe for animation and post-production.",
  },
  {
    icon: "🎥",
    title: "DreamWorks",
    text: "Integrates Adobe tools in movie workflows.",
  },
  {
    icon: "🌌",
    title: "Industrial Light & Magic (ILM)",
    text: "Relies on Adobe for VFX editing.",
  },
  {
    icon: "🎮",
    title: "Blizzard Entertainment",
    text: "Uses Adobe in game cinematic production.",
  },
  {
    icon: "🕹️",
    title: "Ubisoft",
    text: "Employs Adobe for 3D art and game assets.",
  },
  {
    icon: "⚽",
    title: "Electronic Arts (EA)",
    text: "Leverages Adobe for sports game visuals.",
  },
  {
    icon: "🎭",
    title: "Sony Pictures Animation",
    text: "Uses Adobe in animated film production.",
  },
  {
    icon: "🖥️",
    title: "Weta Digital",
    text: "Incorporates Adobe for post-production work.",
  },
  {
    icon: "💻",
    title: "Autodesk",
    text: "Partners with Adobe for design workflows.",
  },
  {
    icon: "👟",
    title: "Nike",
    text: "Uses Adobe for marketing and branding visuals.",
  },
  {
    icon: "🚗",
    title: "Mercedes-Benz",
    text: "Creates campaigns with Adobe Creative Suite.",
  },
  {
    icon: "🥤",
    title: "Coca-Cola",
    text: "Designs ads and packaging using Adobe.",
  },
  {
    icon: "🔍",
    title: "Google",
    text: "Uses Adobe for creative design and branding.",
  },
  {
    icon: "🍏",
    title: "Apple",
    text: "Employs Adobe tools for promotional visuals.",
  },
  {
    icon: "🏰",
    title: "Disney",
    text: "Creates digital media with Adobe software.",
  },
];

const AdobeHeader = () => {
  return (
    <div>
      {/* HERO SECTION */}
      <section
        style={{
          backgroundImage: `url('/assets/5c985e0b67da1a2f01c07a30996f128f.jpg')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "400px", // reduced height
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          textAlign: "center",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* Dark overlay */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.4)",
          }}
        />

        {/* Hero Text */}
        <div
          style={{
            position: "relative",
            zIndex: 1,
            padding: "0 20px",
            color: "white",
          }}
        >
          <h1
            style={{
              fontSize: "36px", // reduced from 48px
              fontWeight: "bold",
              marginBottom: "10px",
            }}
            data-aos="fade-down"
            data-aos-duration="1000"
            className="animate-float"
          >
            Adobe Photoshop
          </h1>

          <p
            style={{
              fontSize: "16px", // reduced from 20px
              maxWidth: "700px",
              margin: "0 auto",
            }}
            data-aos="fade-up"
            data-aos-duration="1200"
            data-aos-delay="300"
          >
            Master the creative power of Photoshop — from image editing to
            professional design techniques.
          </p>

          <a
            href="/contact" // update with your enroll page link
            style={{
              display: "inline-block",
              padding: "12px 30px", // smaller button
              fontSize: "1rem", // smaller text
              fontWeight: "bold",
              color: "#2563eb",
              backgroundColor: "#fff",
              borderRadius: "50px",
              boxShadow: "0 6px 15px rgba(0,0,0,0.2)",
              transition: "all 0.3s ease",
              animation: "bounce 2s infinite",
              textDecoration: "none",
              marginTop: "15px",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "scale(1.1)";
              e.currentTarget.style.boxShadow = "0 12px 30px rgba(0,0,0,0.3)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "scale(1)";
              e.currentTarget.style.boxShadow = "0 6px 15px rgba(0,0,0,0.2)";
            }}
          >
            Enroll Now
          </a>
        </div>

        <style jsx>{`
          @keyframes bounce {
            0%,
            100% {
              transform: translateY(0);
            }
            50% {
              transform: translateY(-10px);
            }
          }
        `}</style>
      </section>

      {/* TOPICS SECTION */}
      <section
        style={{
          padding: "60px 20px",
          maxWidth: "1200px",
          margin: "0 auto",
          boxSizing: "border-box",
        }}
      >
        <h2
          style={{
            textAlign: "center",
            marginBottom: "40px",
            fontSize: "2.5rem",
            fontWeight: "bold",
            color: "#333",
          }}
          data-aos="fade-up"
        >
          Topics You Will Learn
        </h2>

        <div
          style={{
            display: "flex",
            gap: "40px",
            alignItems: "center",
            flexWrap: "wrap",
            justifyContent: "center",
          }}
        >
          {/* Left: Topics with hover + AOS */}
          <div style={{ flex: "1", minWidth: "300px", maxWidth: "600px" }}>
            {topics.map((topic, i) => (
              <div
                key={i}
                style={{
                  display: "flex",
                  gap: "15px",
                  alignItems: "flex-start",
                  padding: "15px",
                  marginBottom: "15px",
                  background: "#f8f8f8",
                  borderRadius: "10px",
                  transition: "transform 0.3s ease, box-shadow 0.3s ease",
                  cursor: "pointer",
                }}
                data-aos="fade-up"
                data-aos-delay={i * 100}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-5px)";
                  e.currentTarget.style.boxShadow =
                    "0 8px 20px rgba(89, 141, 201, 0.89)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "none";
                }}
              >
                <div
                  style={{ fontSize: "28px", color: "#279dd0ff" }}
                  className="animate-bounce"
                >
                  {topic.icon}
                </div>
                <div>
                  <h3
                    style={{
                      margin: "0 0 5px",
                      fontWeight: "bold",
                      color: "black",
                    }}
                  >
                    {topic.title}
                  </h3>
                  <p style={{ margin: 0, fontSize: "14px", color: "#555" }}>
                    {topic.description}
                  </p>
                </div>
              </div>
            ))}
          </div>

          {/* Right: Image */}
          <div
            style={{
              flex: "1",
              minWidth: "300px",
              display: "flex",
              flexDirection: "column", // stack images vertically
              justifyContent: "center",
              alignItems: "center",
              gap: "20px", // space between images
            }}
            data-aos="fade-left"
          >
            <img
              src="/assets/88135384-awesome-adobe-photohop-wallpaper.png"
              alt="Adobe Photoshop"
              style={{
                width: "100%",
                maxWidth: "450px",
                borderRadius: "15px",
                boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
              }}
            />
            <img
              src="/assets/photoshop-intro.jpg"
              alt="Adobe Photoshop"
              style={{
                width: "100%",
                maxWidth: "450px",
                borderRadius: "15px",
                boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
              }}
            />
          </div>
        </div>
      </section>

      {/* WHERE IT CAN BE USED */}
      <section className="py-5 bg-light">
        <h2
          style={{
            textAlign: "center",
            marginBottom: "40px",
            fontSize: "2.5rem",
            fontWeight: "bold",
            color: "#333",
          }}
          data-aos="fade-up"
        >
          Where It Can Be Used
        </h2>
        <div className="container">
          <div className="row g-4">
            {usageAreas.map((area, i) => {
              const colors = [
                "#ff9800",
                "#4caf50",
                "#2196f3",
                "#e91e63",
                "#9c27b0",
                "#00bcd4",
              ];
              return (
                <div
                  key={i}
                  className="col-sm-6 col-lg-4"
                  data-aos="zoom-in-up"
                  data-aos-delay={i * 100}
                >
                  <div
                    className="p-4 text-center rounded position-relative h-100"
                    style={{
                      background: "#fff",
                      boxShadow: "0 4px 15px rgba(0,0,0,0.05)",
                      animation: "shake 3s infinite ease-in-out",
                    }}
                  >
                    {/* colorful corner */}
                    <div
                      style={{
                        position: "absolute",
                        top: 0,
                        right: 0,
                        width: "45px",
                        height: "45px",
                        background: `linear-gradient(135deg, ${
                          colors[i % colors.length]
                        }, transparent)`,
                        borderTopRightRadius: "15px",
                        boxShadow: `0 0 10px ${colors[i % colors.length]}`,
                      }}
                    ></div>
                    <div
                      style={{
                        fontSize: "2rem",
                        color: colors[i % colors.length],
                      }}
                    >
                      {area.icon}
                    </div>
                    <h5 className="fw-bold text-black ">{area.title}</h5>
                    <p className="text-muted small">{area.description}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* COMPANIES Img */}
      <section style={{ padding: 0, margin: 0, textAlign: "center" }}>
        <h1
          style={{
            textAlign: "center",
            marginBottom: "20px",
            paddingTop: "40px",
            fontSize: "2.5rem",
            fontWeight: "bold",
            color: "#333",
          }}
        >
          We Are Going To Work In
        </h1>

        {/* Image */}
        <img
          src={AdobePic} // your Photoshop image import
          alt="Adobe Photoshop Everywhere"
          data-aos="zoom-in"
          style={{
            width: "100%",
            height: "auto",
            maxHeight: "80vh",
            objectFit: "cover",
            borderRadius: "10px",
            boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
          }}
        />

        {/* Content */}
        <p
          style={{
            maxWidth: "900px",
            margin: "30px auto 0",
            fontSize: "1.2rem",
            lineHeight: "1.6",
            color: "#444",
            padding: "0 20px",
          }}
        >
          Photoshop goes everywhere you go. Take your creativity to new places.
          Crop and expand images, adjust colour, add and remove objects and more
          with Photoshop on desktop, web and mobile. Get them all with a
          Photoshop plan or download the mobile app for free.
        </p>
      </section>

      {/* future scope */}

      <section
        style={{
          padding: "60px 20px",
          background: "#fff",
          color: "#333",
          textAlign: "center",
          overflow: "hidden", // important to hide scroll overflow
        }}
      >
        <h2
          style={{
            fontSize: "2.5rem",
            fontWeight: "bold",
            marginBottom: "30px",
          }}
          data-aos="fade-up"
        >
          Future Scope
        </h2>

        <div
          id="my-sc"
          style={{
            display: "flex",
            width: "100%",
            overflow: "hidden",
          }}
        >
          {[0, 1].map((groupIndex) => (
            <div
              key={groupIndex}
              className="scroll-group"
              style={{
                display: "flex",
                gap: "20px",
                flexShrink: 0,
              }}
            >
              {futureScope.map((item, i) => {
                const colors = ["#ff5722", "#673ab7", "#3f51b5", "#009688"];
                return (
                  <div
                    key={i}
                    style={{
                      position: "relative",
                      background: "linear-gradient(145deg, #fdfdfd, #f3f3f3)",
                      borderRadius: "20px",
                      padding: "25px",
                      boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
                      border: "1px solid #eee",
                      transition: "transform 0.3s ease",
                      minWidth: "250px",
                      flexShrink: 0,
                      animation: "shake 3s infinite ease-in-out",
                      animationDelay: `${i * 500}ms`,
                      color: "#333",
                    }}
                    data-aos="fade-up"
                    data-aos-delay={i * 150}
                  >
                    {/* colorful corner */}
                    <div
                      style={{
                        position: "absolute",
                        top: 0,
                        right: 0,
                        width: "35px",
                        height: "35px",
                        background: `linear-gradient(135deg, ${
                          colors[i % colors.length]
                        }, transparent)`,
                        borderTopRightRadius: "20px",
                        boxShadow: `0 0 10px ${colors[i % colors.length]}`,
                      }}
                    ></div>

                    <div style={{ fontSize: "2rem", marginBottom: "10px" }}>
                      {item.icon}
                    </div>
                    <h3
                      style={{
                        fontSize: "1.3rem",
                        fontWeight: "bold",
                        marginBottom: "10px",
                      }}
                    >
                      {item.title}
                    </h3>
                    <p style={{ fontSize: "0.95rem", color: "#555" }}>
                      {item.text}
                    </p>
                  </div>
                );
              })}
            </div>
          ))}
        </div>

        <style jsx>{`
          #my-sc {
            overflow: hidden;
            white-space: nowrap;
          }

          .scroll-group {
            animation: marquee 20s linear infinite;
          }

          @keyframes marquee {
            0% {
              transform: translateX(0);
            }
            100% {
              transform: translateX(-50%);
            }
          }

          @keyframes shake {
            0%,
            100% {
              transform: translate(0, 0) rotate(0);
            }
            20% {
              transform: translate(-1px, 1px) rotate(-0.5deg);
            }
            40% {
              transform: translate(1px, -1px) rotate(0.5deg);
            }
            60% {
              transform: translate(-1px, 1px) rotate(-0.5deg);
            }
            80% {
              transform: translate(1px, -1px) rotate(0.5deg);
            }
          }
        `}</style>
      </section>

      {/* ENROLL SECTION */}
      <section
        style={{
          padding: "60px 20px",
          background: "#2563eb", // strong contrast color
          color: "#fff",
          textAlign: "center",
          position: "relative",
          overflow: "hidden",
        }}
        data-aos="fade-up"
      >
        <h2
          style={{
            fontSize: "2.5rem",
            fontWeight: "bold",
            marginBottom: "20px",
          }}
        >
          Ready to Master Photoshop?
        </h2>
        <p
          style={{
            fontSize: "1.2rem",
            maxWidth: "800px",
            margin: "0 auto 30px",
            lineHeight: "1.6",
          }}
        >
          Enroll in our comprehensive Photoshop course and start creating
          stunning designs today! Gain hands-on experience with tools, effects,
          and advanced techniques used by professionals worldwide.
        </p>

        <a
          href="/contact" // update with your enroll page link
          style={{
            display: "inline-block",
            padding: "15px 40px",
            fontSize: "1.2rem",
            fontWeight: "bold",
            color: "#2563eb",
            backgroundColor: "#fff",
            borderRadius: "50px",
            boxShadow: "0 8px 20px rgba(0,0,0,0.2)",
            transition: "all 0.3s ease",
            animation: "bounce 2s infinite",
            textDecoration: "none",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "scale(1.1)";
            e.currentTarget.style.boxShadow = "0 12px 30px rgba(0,0,0,0.3)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "scale(1)";
            e.currentTarget.style.boxShadow = "0 8px 20px rgba(0,0,0,0.2)";
          }}
        >
          Enroll Now
        </a>

        <style jsx>{`
          @keyframes bounce {
            0%,
            100% {
              transform: translateY(0);
            }
            50% {
              transform: translateY(-10px);
            }
          }
        `}</style>
      </section>
    </div>
  );
};

export default AdobeHeader;
